import { EIsOperatorStatus, IsOperatorMappers } from './types';

export const mappers: IsOperatorMappers = {
  200: (state) => ({
    isOperator: state.isOperator,
    message: null,
    status: EIsOperatorStatus.Success,
  }),
  400: (state) => ({
    isOperator: null,
    message: state.message,
    status: EIsOperatorStatus.Error,
  }),
};
